<template>
  <div class="progressbar-wrapper">
    <div class="progress-item" :class="{'-active': active === 1}" @click="updateStep(1)"><span v-if="active >= 1">1</span></div>
    <div class="progress-item" :class="{'-active': active === 2}" @click="updateStep(2)"><span v-if="active >= 2">2</span></div>
    <div class="progress-item" :class="{'-active': active === 3, '-small': active === 2 || active === 1}" @click="$emit('nextStep', $event)"><span v-if="active >= 3">3</span><span v-else ></span></div>
  </div>
</template>

<script>
export default {
  name: 'Progressbar',
  props: ['active'],
  methods: {
    updateStep: function(index) {
      if (index !== this.active) {
        this.$emit('updateStep', index)
      }
    }
  }
}
</script>
